import React from 'react';
import './home.css';
import Header from '../components/Layout/header';
import '../root.css';
import Footer from '../components/Layout/Footer';
import Hero from '../components/Layout/Hero';
import MainBtn from '../components/Common/Btn';
import { Link } from 'react-router-dom';
import PropertySearch from '../components/Layout/PropertySearch';
import SectionHeader from '../components/Common/SectionHeader';
import AboutCard from '../components/Common/AboutCard';
import ContactForm from '../components/Layout/Contact';
import PropertyCard1 from '../components/Common/PropertyCard1';

const Home = () => {
    return ( 
        <>
        <Header />
        <main>
            <div className="bgGrid"></div>
            <Hero />
            <PropertySearch />
            <section className='About'>
                <SectionHeader SectionStyle="SectionHeader" SectionTitle="About" HighlightedWord="Us" SectionP="We’re a team of experienced real estate professionals dedicated to helping buyers, sellers, and investors navigate the market with confidence. With a focus on transparency and personal attention, we help you make the best real estate decisions."/>

                <div className='AboutStats'>
                    <AboutCard CardName="Experience" CardNum="10+" CardSub="years in local markets"/>
                    <AboutCard CardName="Trust" CardNum="50+" CardSub="Thousands of successful transactions"/>
                    <AboutCard CardName="Service" CardNum="98%" CardSub="Client Satisfaction"/>
                </div>
            </section>

            <section className='vrSec'>
                <div className="row">
                    <SectionHeader SectionStyle="VRSec" SectionTitle="VIRTUAL" HighlightedWord="VIEWING" SectionP="Explore properties remotely through high-definition interactive virtual tours. Navigate spaces in real scale, examine architectural details, and experience spatial flow before scheduling an in-person visit."/>
                    <Link className='link' to='/VR'>
                        <MainBtn btnText="START TOUR" btnStyle="heroBtn" />
                    </Link>
                </div>
            </section>
            <section className='propSec'>
                <SectionHeader SectionStyle="SectionHeader" SectionTitle="Property" HighlightedWord="Listings" SectionP="A selection of premium residences defined by architectural excellence and spatial refinement."/>
                <div className="propRow">
                    <PropertyCard1 floatyBaths="6 Bathrooms" floatyRooms="4 Bedrooms" floatyArea="393 SQM" cardStyle="propertyCard1 house1" propertyName="Twin House" propertyDesc="Spacious Twin House with elegant interiors and a seamless blend of luxury and comfort." />
                    <PropertyCard1 floatyBaths="3 Bathrooms" floatyRooms="3 Bedrooms" floatyArea="298 SQM" cardStyle="propertyCard1 house2" propertyName="Maple House" propertyDesc="Elegant House Villas with spacious layouts, gardens, and premium amenities for luxurious living." />
                    <PropertyCard1 floatyBaths="1 Bathroom" floatyRooms="2 Bedrooms" floatyArea="286 SQM" cardStyle="propertyCard1 house3" propertyName="Zee House" propertyDesc="A modern home with open interiors, stylish finishes, and thoughtfully designed spaces for effortless living." />
                </div>
                <Link className='link' to="/Catalogue" >
                <MainBtn btnText="VIEW MORE" btnStyle="heroBtn" />
                </Link>
            </section>

            <ContactForm />
        </main>
        <Footer />
        </>
     );
}
 
export default Home;